module.exports = __webpack_public_path__ + "static/profil-297_optimized-703f1266f25b600f7affca0a8e11bc7e.jpg";